import React, { FC } from "react";

import {
    ColorCompanyIcon,
    ColorFemaleIcon,
    ColorMaleIcon,
    MonoChromeCompanyIcon,
    MonoChromeUserIcon,
} from "@/assets/icons";
import { isNotEmpty } from "@/core/string";

export enum Variant {
    Monochrome,
    Color,
}

export enum Gender {
    Male = "1",
    Female = "2",
}

type PolicyholderIconProps = {
    className?: string;
    gender?: string | null;
    variant?: Variant;
    isPhysicalPerson?: boolean;
};

enum Combination {
    Company,
    Male,
    Female,
}

const getGender = (gender: string): Gender => {
    return gender === "1" ? Gender.Male : Gender.Female;
};

// eslint-disable-next-line consistent-return
const PolicyholderIcon: FC<PolicyholderIconProps> = ({ gender, className, variant, isPhysicalPerson }) => {
    let combination;
    if (!isPhysicalPerson) {
        combination = Combination.Company;
    } else {
        combination = isNotEmpty(gender) && getGender(gender) === Gender.Female ? Combination.Female : Combination.Male;
    }
    if (variant === Variant.Color) {
        switch (combination) {
            case Combination.Company:
                return <ColorCompanyIcon className={className} />;
            case Combination.Male:
                return <ColorMaleIcon className={className} />;
            case Combination.Female:
                return <ColorFemaleIcon className={className} />;
        }
    }
    switch (combination) {
        case Combination.Company:
            return <MonoChromeCompanyIcon className={className} />;
        case Combination.Male:
        case Combination.Female:
            return <MonoChromeUserIcon className={className} />;
    }
};

export default PolicyholderIcon;
